import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { IntegrationType } from 'helpers/integration/IntegrationType';
import EtoAuthError from 'components/AuthError/EtoAuthError';
import ApricotAuthError from 'components/AuthError/ApricotAuthError';
import { IAuthErrorMessage } from './AuthErrorMsg';
import { SSOAPIContextParser } from 'services/api-context-service/sso-api-context-parser';
import { ErrorDetails } from 'models/context/error-details';

const AuthError = (): React.ReactElement => {

    type ProductType = {
        productType: string;
    };

    const { productType } = useParams<ProductType>();
    const { search } = useLocation();
    const query = React.useMemo(() => new URLSearchParams(search), [search]);
    const errorCode = query.get('error_code');
    const params = query.get('params');
    const rawContext = query.get('context');
    const jsonParams = params !== null ? JSON.parse(decodeURIComponent(params)) : {};
    let errorDetails: ErrorDetails = {};
    if (rawContext !== null) {
        try {
            errorDetails = SSOAPIContextParser.getSSOAPIContextFromQueryParam(rawContext);
        } catch (err: unknown) {
            errorDetails = {
                react_error: `Failed to parse api context: ${(err as Error).message}`,
            };
        }
    }
    const errorProps: IAuthErrorMessage = {
        errorCode,
        jsonParams,
        errorDetails
    };

    return ( productType === IntegrationType.Apricot.toLowerCase() ? <ApricotAuthError {...errorProps} /> : <EtoAuthError {...errorProps} /> );
};

export default AuthError;
